import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { loadState } from "./utils/poolTools";

import reducers from "./reducers";

const store = createStore(
  combineReducers(reducers),
  { poll: loadState("poll-form", { page: 0 }) }, // TODO   na produkcji w hashu: { page: 0 }
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js